import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Paper, Typography, Button } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';

import InputAdornment from '@material-ui/core/InputAdornment';
import MicIcon from '@material-ui/icons/Mic';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Rating from './Rating';
import RadioOptions from './RadioOptions';
import Methodo from './Methodo';

const animatedComponents = makeAnimated();

const methodologies = [
  'EV/Revenues',
  'EV/EBITDA',
  'EV/EBITA',
  'EV/(EBITDA - Capex)',
  'EV/(EBITDA - Capex - Tax)',
  'PER',
  'DCF',
  'Unlevered FCF yield (%)',
  'Equity FCF yield (%)',
  'Other(s)'
];

const createOption = (label) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, '')
});

const companyData = [
  createOption(
    'iShares MSCI All Country Asia Information Technology index Fund'
  ),
  createOption('Atlantic American Corporation'),
  createOption('Applied Optoelectronics, Inc.'),
  createOption('AAON, Inc.'),
  createOption('Apple Inc.'),
  createOption('Avalanche Biotechnologies, Inc.'),
  createOption('Atlas Air Worldwide Holdings'),
  createOption('iShares MSCI All Country Asia ex Japan Index Fund'),
  createOption('Aoxin Tianli Group, Inc.'),
  createOption('ABAXIS, Inc.'),
  createOption('Ameris Bancorp'),
  createOption('Cambium Learning Group, Inc.'),
  createOption('The Advisory Board Company'),
  createOption('Anchor BanCorp Wisconsin Inc.'),
  createOption('Abengoa, S.A.'),
  createOption('ARCA biopharma, Inc.'),
  createOption('ARCA biopharma, Inc.'),
  createOption('ABIOMED, Inc.'),
  createOption('Autobytel Inc.'),
  createOption('Abengoa Yield plc'),
  createOption('ACADIA Pharmaceuticals Inc.'),
  createOption('American Capital, Ltd.'),
  createOption('Arctic Cat Inc.'),
  createOption('Aceto Corporation'),
  createOption('Atlantic Coast Financial Corporation'),
  createOption('Acorn Energy, Inc.'),
  createOption('Arch Capital Group Ltd.'),
  createOption('Acadia Healthcare Company, Inc.'),
  createOption('Achillion Pharmaceuticals, Inc.'),
  createOption('ACI Worldwide, Inc.'),
  createOption('Axcelis Technologies, Inc.'),
  createOption('ACNB Corporation'),
  createOption('Acorda Therapeutics, Inc.'),
  createOption('Active Power, Inc.'),
  createOption('AcelRx Pharmaceuticals, Inc.'),
  createOption('American Capital Senior Floating, Ltd.'),
  createOption('Acasti Pharma, Inc.'),
  createOption('Actua Corporation'),
  createOption('Acacia Research Corporation'),
  createOption('Actions Semiconductor Co., Ltd.'),
  createOption('Acura Pharmaceuticals, Inc.'),
  createOption('iShares MSCI ACWI Index Fund'),
  createOption('iShares MSCI ACWI ex US Index Fund')
];

const useStyles = makeStyles((theme) => ({
  container: {
    width: '85%',
    margin: '0 auto'
  },
  textContainer: {
    margin: '1.5rem 0'
  },
  paperContainer: {
    padding: '1rem 4rem'
  },
  text: {
    fontFamily: 'PT sans',
    fontSize: '14px'
  },
  desc: {
    fontFamily: 'PT serif',
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#252525',
    margin: '1rem 0'
  },
  instructions: {
    fontFamily: 'PT sans',
    fontSize: '16px'
  },
  valueInfo: {
    marginBottom: '2.5rem'
  },
  textField: {
    marginTop: '.5rem',
    width: '100%'
  },
  inputStrWeak: {
    marginTop: '.5rem',
    marginRight: '1rem',
    width: '35ch'
  },
  inputs: {
    display: 'flex',
    marginTop: '1.5rem',
    width: '100%'
  },
  strweak: {
    display: 'block',
    fontFamily: 'PT sans',
    fontSize: '16px',
    color: '#252525'
  },
  add: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#002380',
    marginTop: '.3rem'
  },
  buttonDiv: {
    textAlign: 'right'
  },
  save: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'Capitalize',
    fontWeight: 'bold',
    borderColor: '#002380',
    borderRadius: 0,
    marginRight: '1rem'
  },
  send: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'Capitalize',
    fontWeight: 'bold',
    borderRadius: 0
  }
}));

// searchpeers style
const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: 'none',
    padding: '7px 9px'
  })
};

const FeedBackSent = () => {
  const [feedbackFetched, setFeedbackFetched] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [checked, setChecked] = useState(false);
  const [state, setState] = useState({
    executionStrategy: 5,
    financialPosition: 3,
    qualityManagement: 7,
    valuationWhy: '',
    strengths: '',
    weaknesses: '',
    opinionOnValuation: '',
    challenges: '',
    influence: '',
    risks: '',
    comments: '',
    valuationMethodos: []
  });

  const classes = useStyles();

  useEffect(() => {
    const fetchData = () => {
      setTimeout(() => {
        setFeedbackFetched({ ok: 'data fetched' });
        setIsLoading(false);
      }, 3500);
    };
    fetchData();
  }, []);

  const handleChangeChecked = (e) => {
    setChecked(e.target.checked);
  };

  const handleChangeState = ({ target: { name, value } }) => {
    setState({ ...state, [name]: value });
  };

  const handleChangeValuationMethodo = (e, value, methodo) => {
    if (value) {
      setState({
        ...state,
        valuationMethodos: [...state.valuationMethodos, methodo]
      });
    } else {
      setState({
        ...state,
        valuationMethodos: [
          ...state.valuationMethodos.filter((metho) => metho !== methodo)
        ]
      });
    }
  };

  const feedbackObj = {
    feedback_informations: {
      additional_comment: state.comments,
      execution_of_strategy: state.executionStrategy.toString(),
      financial_position: state.financialPosition.toString(),
      influence_on_valuation: state.influence,
      management_challenges: state.challenges,
      oovalue_comment: '',
      opinion_on_value: state.opinionOnValuation,
      qom_comment: '',
      quality_of_management: state.qualityManagement.toString(),
      risk_factors_appreciaiton: state.risks,
      strenghts: state.strengths,
      weaknesses: state.weaknesses
    },
    peer_investments: [
      {
        date_of_peer_investment: 'string',
        peer: {
          id: 0
        }
      }
    ],
    sent: true,
    valuation_methodologies: [{ ...state.valuationMethodos, id: 0 }]
  };

  return (
    <>
      {!isLoading ? (
        <div className={classes.container}>
          <div className={classes.textContainer}>
            <Typography className={classes.text} color="initial" variant="p">
              Please fill in the following key questions in order to fully
              assess your appreciation of the investment case. You can also
              solicit a meeting with the company and its top management that
              could take place physically or via video-conference.
            </Typography>
            <br />
            <br />
            <Typography className={classes.text} color="initial" variant="p">
              We represent and certify that this information will be kept
              confidential to other investors and third parties to the exclusion
              of company's advisors that are also bound by a non-disclosure
              agreement.
            </Typography>
          </div>
          <Paper className={classes.paperContainer}>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Execution of strategy
              </Typography>
              <Typography className={classes.instructions}>
                Please rate management key strategic decisions communication and
                execution:
              </Typography>
              <Rating
                high="High quality"
                low="Low quality"
                onChange={(e, newValue) =>
                  setState({ ...state, executionStrategy: newValue })
                }
                value={state.executionStrategy}
              />
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Financial position
              </Typography>
              <Typography className={classes.instructions}>
                Please rate management key strategic decisions communication and
                execution:
              </Typography>
              <Rating
                high="Strong"
                low="Weak"
                onChange={(e, newValue) =>
                  setState({ ...state, financialPosition: newValue })
                }
                value={state.financialPosition}
              />
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Quality of management
              </Typography>
              <Typography className={classes.instructions}>
                Please rate management key strategic decisions communication and
                execution:
              </Typography>
              <Rating
                high="High quality"
                low="Low quality"
                onChange={(e, newValue) =>
                  setState({ ...state, qualityManagement: newValue })
                }
                value={state.qualityManagement}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    color="primary"
                    name="checked"
                    onChange={handleChangeChecked}
                  />
                }
                label="Additional comment (optional)"
              />
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Opinion on valuation proposed
              </Typography>
              <RadioOptions
                handleChange={(e) =>
                  setState({ ...state, opinionOnValuation: e.target.value })
                }
                value={state.opinionOnValuation}
              />
              <br />
              <FormControl className={classes.textField} variant="outlined">
                <OutlinedInput
                  endAdornment={
                    <InputAdornment position="end">
                      <MicIcon />
                    </InputAdornment>
                  }
                  id="outlined-adornment-valuation"
                  inputProps={{
                    'aria-label': 'why'
                  }}
                  labelWidth={0}
                  name="valuationWhy"
                  onChange={handleChangeState}
                  placeholder="Why?"
                  value={state.valuationWhy}
                />
              </FormControl>
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Strenghts & weaknesses
              </Typography>
              <Typography className={classes.instructions}>
                Please use keywords separated by a coma (example: strong,
                independant).
              </Typography>
              <div className={classes.inputs}>
                <div>
                  <Typography
                    className={classes.strweak}
                    color="initial"
                    variant="h6">
                    Strenghts
                  </Typography>

                  <FormControl
                    className={classes.inputStrWeak}
                    variant="outlined">
                    <OutlinedInput
                      endAdornment={
                        <InputAdornment position="end">
                          <MicIcon />
                        </InputAdornment>
                      }
                      id="outlined-adornment-valuation"
                      inputProps={{
                        'aria-label': 'strenghts'
                      }}
                      labelWidth={0}
                      multiline
                      name="strengths"
                      onChange={handleChangeState}
                      rows={4}
                      rowsMax={4}
                      value={state.strengths}
                    />
                  </FormControl>
                </div>

                <div>
                  <Typography
                    className={classes.strweak}
                    color="initial"
                    variant="h6">
                    Weaknesses
                  </Typography>
                  <FormControl
                    className={classes.inputStrWeak}
                    variant="outlined">
                    <OutlinedInput
                      endAdornment={
                        <InputAdornment position="end">
                          <MicIcon />
                        </InputAdornment>
                      }
                      id="outlined-adornment-valuation"
                      inputProps={{
                        'aria-label': 'Weaknesses'
                      }}
                      labelWidth={0}
                      multiline
                      name="weaknesses"
                      onChange={handleChangeState}
                      rows={4}
                      rowsMax={4}
                      value={state.weaknesses}
                    />
                  </FormControl>
                </div>
              </div>
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Management challenges
              </Typography>
              <Typography className={classes.instructions}>
                Please list the few challenges that the management of the issuer
                would be facing:
              </Typography>
              <FormControl className={classes.textField} variant="outlined">
                <OutlinedInput
                  endAdornment={
                    <InputAdornment position="end">
                      <MicIcon />
                    </InputAdornment>
                  }
                  id="outlined-adornment-valuation"
                  inputProps={{
                    'aria-label': 'challenges'
                  }}
                  labelWidth={0}
                  multiline
                  name="challenges"
                  onChange={handleChangeState}
                  rows={4}
                  rowsMax={4}
                  value={state.challenges}
                />
              </FormControl>
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Influence on valuation
              </Typography>
              <Typography className={classes.instructions}>
                Please list key factors that could positively or negatively
                impact valuation:
              </Typography>
              <FormControl className={classes.textField} variant="outlined">
                <OutlinedInput
                  endAdornment={
                    <InputAdornment position="end">
                      <MicIcon />
                    </InputAdornment>
                  }
                  id="outlined-adornment-valuation"
                  inputProps={{
                    'aria-label': 'influence'
                  }}
                  labelWidth={0}
                  multiline
                  name="influence"
                  onChange={handleChangeState}
                  rows={4}
                  rowsMax={4}
                  value={state.influence}
                />
              </FormControl>
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Valuation methodologies
              </Typography>
              <Typography className={classes.instructions}>
                Select the top 3 methodologies to best evaluate the issuer:
              </Typography>

              {methodologies.map((methodo) => (
                <>
                  <Methodo
                    checked={state.valuationMethodos.includes(methodo)}
                    handleChange={(e, value) =>
                      handleChangeValuationMethodo(e, value, methodo)
                    }
                    label={methodo}
                  />
                  <br />
                </>
              ))}
              <FormControl className={classes.textField} variant="outlined">
                <OutlinedInput
                  endAdornment={
                    <InputAdornment position="end">
                      <MicIcon />
                    </InputAdornment>
                  }
                  id="outlined-adornment-valuation"
                  inputProps={{
                    'aria-label': 'why'
                  }}
                  labelWidth={0}
                  name="valuationWhy"
                  onChange={handleChangeState}
                  placeholder="Why?"
                  value={state.valuationWhy}
                />
              </FormControl>
            </div>

            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Have you invested in peers?
              </Typography>
              <div>
                <Typography
                  className={classes.strweak}
                  color="initial"
                  variant="h6">
                  Peer name
                </Typography>
                <br />
                <Select
                  closeMenuOnSelect={false}
                  components={animatedComponents}
                  isMulti
                  options={companyData}
                  placeholder="type here"
                  styles={customStyles}
                />
              </div>
            </div>

            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Your appreciation of the risk factors
              </Typography>
              <Typography className={classes.instructions}>
                Please list the risk factors that in your view are the most
                relevant
              </Typography>
              <FormControl className={classes.textField} variant="outlined">
                <OutlinedInput
                  endAdornment={
                    <InputAdornment position="end">
                      <MicIcon />
                    </InputAdornment>
                  }
                  id="outlined-adornment-valuation"
                  inputProps={{
                    'aria-label': 'influence'
                  }}
                  labelWidth={0}
                  multiline
                  name="risks"
                  onChange={handleChangeState}
                  rows={4}
                  rowsMax={4}
                  value={state.risks}
                />
              </FormControl>
            </div>
            <div className={classes.valueInfo}>
              <Typography className={classes.desc} color="initial" variant="h1">
                Additional comment (optional)
              </Typography>
              <Typography className={classes.instructions}>
                Please write here any additional comment that you deem relevant
                or useful:
              </Typography>
              <FormControl className={classes.textField} variant="outlined">
                <OutlinedInput
                  endAdornment={
                    <InputAdornment position="end">
                      <MicIcon />
                    </InputAdornment>
                  }
                  id="outlined-adornment-valuation"
                  inputProps={{
                    'aria-label': 'influence'
                  }}
                  labelWidth={0}
                  multiline
                  name="comments"
                  onChange={handleChangeState}
                  rows={4}
                  rowsMax={4}
                  value={state.comments}
                />
              </FormControl>
            </div>
            <div className={classes.buttonDiv}>
              <Button
                className={classes.save}
                color="primary"
                onClick={() => console.log({ ...feedbackObj, sent: false })}
                variant="outlined">
                Save answers
              </Button>
              <Button
                className={classes.send}
                color="primary"
                onClick={() => console.log({ ...feedbackObj, sent: true })}
                variant="contained">
                Send feedback
              </Button>
            </div>
          </Paper>
        </div>
      ) : (
        <LinearProgress />
      )}
    </>
  );
};

export default FeedBackSent;
